import { useCLickEvent } from '@/hooks/use-tracker'
import DemoLinkButton from '../../parts/DemoLinkButton'
import LinkButton from '../../parts/LinkButton'

export function Request({ position }: { position: string }) {
  const { pushGa4ClickEvent } = useCLickEvent()
  return (
    <section className="bg-lawguebase">
      <div className="text-center lg:max-w-[60rem] mx-auto py-10 w-full lg:py-20">
        <div className="relative">
          <h2 className="text-center lg:text-2xl text-base text-textblack font-bold fontfeaturesettings">
            さあ、新しいドキュメント作成をはじめましょう
          </h2>

          <div className="mt-4 lg:mt-10 flex gap-4 justify-center">
            <DemoLinkButton
              label="ライブデモを体験"
              sublabel="LAWGUEを今すぐ試す！"
              variant="primary"
            />
            <LinkButton
              href="/request"
              size="xlarge"
              bg="visible"
              label="資料をダウンロード"
              onClick={() => {
                pushGa4ClickEvent({
                  eventCategory: 'request',
                  eventUi: `top-${position}-after`
                })
              }}
            />
          </div>

          <img
            src="/images/img_info.svg"
            alt="資料をダウンロード"
            className="w-[8.5rem] mx-auto mb-3 absolute top-[-6rem] left-0 lg:w-[320px] lg:top-[-14rem] lg:left-[-6rem]"
            width={320}
            height={213}
          />
        </div>
      </div>
    </section>
  )
}
